import { AbstractGameController } from "@lib/titan2/dist/game/controller/AbstractGameController";
import { EventObject } from "@lib/titan2/dist/util/event/EventObject";
import { gsap } from "gsap";
import { FeatureTransitionEvents } from "./FeatureTransitionController";
import { FeatureRedFishEvents } from "../view/abstract/display/features/redfish/FeatureRedFish";
import { GameBigWinEvents } from "../view/abstract/display/GameBigWin";
import { Service } from "@lib/titan2-slingo/dist/api/Service";
import { GameEvent } from "./event/GameEvent";
import { SeededRandom } from "../utils/SeededRandom";
import { MainTransitionEvents } from "../view/abstract/display/GameMainTransition";
import { GameLadyMeowSoundEvents } from "./event/GameSountEvent";
export class FeatureRedFishController extends AbstractGameController {
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(FeatureRedFishControllerEvents.BEGIN_FEATURE, this.handleBeginFeature);
    }
    async handleBeginFeature() {
        const availableBoxIndexes = Array.from({ length: 3 }, (x, i) => i);
        const seededRandomUserChoice = new SeededRandom(this.model.getGameInstanceId());
        const data = this.model.getRedFishChanceGameData();
        this.dispatchGame(FeatureRedFishEvents.FEATURE_START);
        await this.blockUntil(FeatureRedFishEvents.PICKS_READY);
        let index;
        if (Service.isReplay()) {
            await this.delayFor(1);
            index = this.model.consumeNextUserChoice();
            if (index === null) {
                index = seededRandomUserChoice.pickFromArray(availableBoxIndexes);
            }
        }
        else {
            index = (await this.blockUntil(FeatureRedFishEvents.PICK_SELECTED)).getPayload()["index"];
            this.dispatchGame(GameEvent.createUserchoiceMadeEvent({ choice: index }));
        }
        //Play this sound in replay aswell.
        this.dispatchGame(GameLadyMeowSoundEvents.BOX_SELECTED);
        this.dispatchGame(new EventObject(FeatureRedFishEvents.REVEAL_PRIZES.getType(), {
            index,
            pickedIndex: index,
            pickedInitialValue: data.getInitialPickValue(),
            missedInitialValues: data.getInitialPickMissedValues()
        }));
        await this.blockUntil(FeatureRedFishEvents.REVEAL_PRIZES_COMPLETE);
        await this.delayFor(2);
        for (const kiss of data.getKisses()) {
            this.dispatchGame(new EventObject(FeatureRedFishEvents.KISS.getType(), { pickedIndex: index, kiss }));
            await this.blockUntil(FeatureRedFishEvents.KISS_COMPLETE);
        }
        this.dispatchGame(FeatureRedFishEvents.SOLD);
        await this.blockUntil(FeatureRedFishEvents.SOLD_COMPLETE);
        this.dispatchGame(FeatureTransitionEvents.TRANSITION_WIN_PARTICLE);
        this.dispatchGame(GameBigWinEvents.PLAY);
        await this.blockUntil(GameBigWinEvents.COMPLETE);
        this.dispatchGame(FeatureTransitionEvents.TRANSITION_BACK_TO_BASE_GAME);
        await this.blockUntil(MainTransitionEvents.BLACKOUT_MID_POINT);
        this.dispatchGame(FeatureRedFishEvents.CLEAR);
    }
    createModel() {
        super.createModel();
        this.model = this.baseModel;
    }
    async blockUntil(event) {
        return new Promise(resolve => {
            this.registerGame(event, (recievedEvent) => {
                this.unregisterGame(event);
                resolve(recievedEvent);
            });
        });
    }
    async delayFor(timeInSeconds) {
        return new Promise(resolve => {
            gsap.delayedCall(timeInSeconds, resolve);
        });
    }
}
export class FeatureRedFishControllerEvents {
}
FeatureRedFishControllerEvents.BEGIN_FEATURE = new EventObject("FeatureRedFishEvents.BEGIN_FEATURE");
//# sourceMappingURL=FeatureRedFishController.js.map